import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { shareReplay, switchMap, throttleTime } from 'rxjs/operators';

export class SimpleFinn<T> {
  private networkActive$$ = new BehaviorSubject<boolean>(false);
  public networkActive$ = this.networkActive$$.asObservable().pipe(shareReplay(1));
  private bSubject$$: BehaviorSubject<T>;
  private throttle$$ = new Subject();
  private readonly shared$: Observable<T>;
  private readonly loadFunc: () => Promise<T> | Observable<T>;

  constructor(initValue: T = null, loadFunc: () => Promise<T> | Observable<T>) {
    this.bSubject$$ = new BehaviorSubject<T>(initValue);
    this.shared$ = this.bSubject$$.asObservable().pipe(shareReplay(1));
    this.loadFunc = loadFunc;
    this.throttle$$
      .pipe(
        throttleTime(1000),
        switchMap(() => {
          this.networkActive$$.next(true);
          return this.loadFunc();
        }),
      )
      .subscribe({
        next: (value) => {
          this.bSubject$$.next(value);
          this.networkActive$$.next(false);
        },
        error: (err) => {
          this.networkActive$$.next(false);
        },
      });
  }

  public get$(): Observable<T> {
    this.throttle$$.next();
    return this.shared$;
  }
}
